import { custom } from 'devextreme/ui/dialog'

export const confirmDialog = async (title: string, message: string) => {
	const dialog = custom({
		title: title,
		messageHtml: message,
		buttons: [
			{
				text: 'Yes',
				onClick: e => ({ buttonText: 'Yes', clicked: true }),
			},
			{
				text: 'No',
				onClick: e => ({ buttonText: 'No', clicked: false }),
			},
		],
	})
	try {
		const result = await dialog.show()
		return result.clicked
	} catch (error) {
		// Handle dialog dismissal (Escape key or clicking outside)
		return false
	}
}
